export const regex = {
  naturalNumbers: /^[1-9][0-9]*$/,
  alphabets: /^[A-Za-z\s]+$/,
  wholeNumbers: /^[0-9]{1,12}$/,
  idNumber: /^[0-9]+$/,
  decimal: /^\d+(\.\d{1,2})?$/,
  numbersAndDecimal: /^\d+(\.\d+)?$/,
  alphaNumeric: (isLimited = false, isSpacing = true) => {
    return isSpacing ? /^[0-9a-zA-Z\s]*$/ : isLimited ? /^[0-9a-zA-Z]{1,5}$/ : /^[0-9a-zA-Z]*$/
  },
  alphaNumericSpecialCharacter: () => {
    return /^[a-zA-Z0-9!@#$%^&*()_+[\]{};':",.<>?/\\|\- ]*$/
  },
  phoneNumber: /^((\+92)?(0092)?(92)?(0)?)(3)([0-9]{9})$/gm,
  arabPhoneNumber: /^(009665|9665|\+9665|05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/gm,
  number: (isNonZero = false) => {
    return isNonZero ? /^[0-9]{1,12}$/ : /^([1-9]|([1-9]\d{1,11}))$/
  },
  websiteRegex: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/,
  emailRegex: /^([A-Za-z0-9_])([A-Za-z0-9_.-]*)@([A-Za-z0-9-]+\.)+([A-Za-z0-9]{2,4})+$/,
  extraBonusEmailRegex: /^([a-zA-Z_])([a-zA-Z0-9_\.\-])+\@(zameen|bayut|dubizzlelabs)\.(com|co|sa)$/,
  cnicRegex: /^[0-9]{5}-[0-9]{7}-[0-9]$/,
  idRegex: /@"^[0-9-]*$"/,
  nameRegex: /^[a-z ,.'-]+$/i,
  arabicRegex: /^[\u0621-\u064A0-9 ]+$/,
  arabicAlphabetsRegex: /^[\u0621-\u064A ]+$/,
  ksaFinanceRegex: /^[a-zA-Z0-9\s\-/\\/]+$/, // this regex includes: alphanumeric, spaces, dashes and backslashes
  ksaOnlinePaymentRegex: /^[a-zA-Z0-9\s\-]+$/, //does not  include back-slashes
}
